export default "__VITE_ASSET__038891ad__"